export default __webpack_public_path__ + "static/media/bullet-true-blue.7da46c9b.svg";